import { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import HomePage from "./home_page";
import DiscoverPage from "./discover_page";
import DetailsPage from "./complete_info";
import Login from "./Login";
import Signup from "./Signup";
import PrivateRoute from "./PrivateRoute"; // <-- Import your PrivateRoute
// import ManageUsers from "./components/manage_users";
import LatestUseCases from "./components/latest_usecases";
import StartupAcquisitionPage from "./components/startupacquastion_page";
import ResetPassword from "./components/ResetPassword";
import ForgotPassword from "./components/ForgotPassword";
import UserAnalytics from "./user_analytics";
import AboutUs from "./about_us";
import CompanyDetailPage from "./components/CompanyDetailPage";
import SolutionCompanyDetailPage from "./components/solutionProviderCompanyDetails";
import VentureCapitalistPage from "./components/VentureCapitalist";
// New Admin Pages
import AdminPanel from "./pages/AdminPanel";
import ExcelUpload from "./pages/ExcelUpload";
import StartupSearch from "./pages/StartupSearch";
import StartupDetailPage from "./pages/StartupDetail";
// New UCDP_SIR Pages
import StartupDiscoveryPage from "./components/StartupDiscoveryPage";
import VCIntelligencePage from "./components/VCIntelligencePage";
import VCDetailPage from "./components/VCDetailPage";
import UseCaseTrendsPage from "./components/UseCaseTrendsPage";
import AcquisitionDashboardPage from "./components/AcquisitionDashboardPage";
import StartupEngagementRepo from "./pages/StartupEngagementRepo";

// Create a ScrollToTop component
function ScrollToTop() {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Add ScrollToTop component inside Router */}
      <Suspense
        fallback={
          <div className="min-h-screen bg-gradient-to-b from-[#0a1833] to-black flex flex-col items-center justify-center gap-4">
            <div className="relative">
              <div className="w-12 h-12 rounded-full absolute border-4 border-solid border-gray-200"></div>
              <div className="w-12 h-12 rounded-full animate-spin absolute border-4 border-solid border-green-400 border-t-transparent"></div>
            </div>
            <div className="text-green-400 text-lg font-medium"></div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/discover"
            element={
              <PrivateRoute>
                <DiscoverPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/details/:id"
            element={
              <PrivateRoute>
                <DetailsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/startup-acquisition"
            element={
              <PrivateRoute>
                <StartupAcquisitionPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-users"
            element={
              <PrivateRoute>
                <UserAnalytics />
              </PrivateRoute>
            }
          />
          <Route
            path="/solution-company/:companyName"
            element={
              <PrivateRoute>
                <SolutionCompanyDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/venture-capitalist"
            element={
              <PrivateRoute>
                <VentureCapitalistPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/company/:companyName"
            element={<CompanyDetailPage />}
          />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          {/* <Route path="/manage-users" element={<ManageUsers />} /> */}
          <Route path="/use-cases" element={<LatestUseCases />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* Engagement Repository */}
          <Route
            path="/engagement-repo"
            element={
              <PrivateRoute>
                <StartupEngagementRepo />
              </PrivateRoute>
            }
          />
          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminPanel />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/excel-upload"
            element={
              <PrivateRoute>
                <ExcelUpload />
              </PrivateRoute>
            }
          />
          {/* Startup Directory - Public */}
          <Route path="/startups" element={<StartupSearch />} />
          <Route path="/startup/:id" element={<StartupDetailPage />} />
          {/* AI-Powered Discovery Pages */}
          <Route
            path="/startup-discovery"
            element={
              <PrivateRoute>
                <StartupDiscoveryPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/vc-intelligence"
            element={
              <PrivateRoute>
                <VCIntelligencePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/vc/:id"
            element={
              <PrivateRoute>
                <VCDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/acquisition-dashboard"
            element={
              <PrivateRoute>
                <AcquisitionDashboardPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/usecase-trends"
            element={
              <PrivateRoute>
                <UseCaseTrendsPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
